export default function AppSpinner({
  className = "",
  sizeClass = "w-10 h-10",
  borderClass = "border-4",
}) {
  return (
    <div
      className={`${sizeClass} ${borderClass} animate-spin rounded-full border-[#F93209] border-t-transparent ${className}`}
      aria-label="loading"
    />
  );
}
